import { firstValueFrom, timeout } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular/standalone';
import { ApiService, SessionConfig, SessionHooks } from '@movilidad/app-core';
import { QueryClient } from '@tanstack/angular-query-experimental';

/** A dónde mandan los guards. */
export const SESSION: SessionConfig = {
  routes: {
    signedOut: '/login',
    home: () => '/tabs/viajes',
  },
};

/** Si el API no responde en este tiempo, la sesión local se cierra igual: siempre se puede salir. */
const REVOKE_TIMEOUT_MS = 5000;

/** Lo que Passenger hace al cerrar sesión. El push (FCM) se da de baja aquí cuando exista. */
@Injectable({ providedIn: 'root' })
export class PassengerSessionHooks implements SessionHooks {
  private readonly api = inject(ApiService);
  private readonly queryClient = inject(QueryClient);
  private readonly nav = inject(NavController);

  /** Revoca el token en el servidor; aquí todavía sigue guardado. Si ya venció, el 401 se ignora. */
  async beforeLogout(): Promise<void> {
    await firstValueFrom(this.api.post('logout', {}).pipe(timeout(REVOKE_TIMEOUT_MS))).catch(() => undefined);
  }

  onLogout(): void {
    this.queryClient.clear();
  }

  async afterLogout(): Promise<void> {
    // navigateRoot limpia las pilas de pestañas: lo de esta sesión no debe quedar detrás del login.
    await this.nav.navigateRoot(SESSION.routes.signedOut);
  }
}
